/** Strip legacy all-{slug} path segments (pre-generic browse URLs). */
export function stripLegacyAllPrefixSegments(segments: string[]): string[] {
  return segments.map(segment => {
    if (segment.startsWith('all-') && segment.length > 4) {
      return segment.slice(4);
    }
    return segment;
  });
}

/** Rewrite legacy browse URLs (e.g. /test3/wow/all-test4/all → /test3/wow/test4/all). */
export function canonicalBrowseRouterUrl(fullUrl: string): string | null {
  const hashIdx = fullUrl.indexOf('#');
  const hash = hashIdx >= 0 ? fullUrl.slice(hashIdx) : '';
  const withoutHash = hashIdx >= 0 ? fullUrl.slice(0, hashIdx) : fullUrl;
  const qIdx = withoutHash.indexOf('?');
  const query = qIdx >= 0 ? withoutHash.slice(qIdx) : '';
  const path = qIdx >= 0 ? withoutHash.slice(0, qIdx) : withoutHash;
  const segments = path.split('/').filter(Boolean);
  if (!segments.length) {
    return null;
  }

  const normalized = stripLegacyAllPrefixSegments(segments);
  const changed = normalized.some((seg, i) => seg !== segments[i]);
  if (!changed) {
    return null;
  }

  return `/${normalized.join('/')}${query}${hash}`;
}
